import classNames from 'classnames';

import { ClassNameType } from 'interfaces';

const styles = {
  component: (
    className: ClassNameType,
    type: string,
  ) => {
    const defaultButtonsClasses = classNames(
      'relative',
    );
    let customInputClasses = '';

    switch (type) {
      case 'checkbox':
        customInputClasses = classNames(
          'flex',
          'justify-between',
          '!mt-5',
          'items-center',
        );
        break;
      default:
        break;
    }

    return classNames(
      defaultButtonsClasses,
      customInputClasses,
      className,
    );
  },
  label: (isCheckbox: boolean = false) => classNames(
    'block',
    'font-bold',
    {
      'text-mainBlue': !isCheckbox,
      '!mb-1.5': !isCheckbox,
    },
    {
      'text-secondaryBlue': isCheckbox,
      'text-xl': isCheckbox,
    },
  ),
  input: (error: boolean = false, hide: boolean = false) => (classNames(
    'bg-lightGray',
    'border',
    'w-full',
    '!border-b-4',
    'text-mainBlue',
    'invalid:border-error',
    {
      'border-b-paleGray': !error,
      'border-b-error': error,
      hidden: hide,
    },
  )),
  placeholder: (withLabel: boolean = false) => (classNames(
    'absolute',
    'opacity-50',
    'lowercase',
    'right-3',
    {
      'top-11': withLabel,
      'top-2': !withLabel,
    },
  )),
  error: classNames(
    'block',
    'text-error',
    '!mt-2',
  ),
  checkbox: (isActive: boolean = false) => classNames(
    'relative',
    'rounded-[20px]',
    'h-9',
    'w-[60px]',
    'p-1',
    'block',
    'cursor-pointer',
    'transition-all',
    {
      'bg-secondaryBlue': isActive,
      'bg-paleGray-500': !isActive,
    },
  ),
  icon: (isActive: boolean = false) => classNames(
    'items-center',
    'bg-white',
    'flex',
    'h-full',
    'justify-center',
    'rounded-full',
    'w-7',
    'transition-all',
    {
      'ml-6': isActive,
      'text-secondaryBlue': isActive,
    },
  ),
};

export default styles;
